import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-26c0d999")

_pushScopeId("data-v-26c0d999")
const _hoisted_1 = {
  key: 0,
  class: "px-9 pt-5 d-flex justify-content-center"
}
const _hoisted_2 = { class: "seq-encash-banner" }
const _hoisted_3 = { class: "seq-encash-banner__icon svg-icon svg-icon-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "seq-encash-banner__text" }, [
  /*#__PURE__*/_createVNode("span", { class: "seq-encash-banner__title" }, "Turn your commissions into cash"),
  /*#__PURE__*/_createVNode("span", { class: "seq-encash-banner__desc" }, "Pick a source, enter how much you'd like to withdraw, and do not forget to confirm the details.")
], -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_7 = { class: "mw-500px mx-auto" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label" }, "You encash exactly", -1)
const _hoisted_10 = { class: "seq-amount-field seq-amount-field--source" }
const _hoisted_11 = { class: "seq-amount-field__side" }
const _hoisted_12 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select source", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "DRC" }, "Personal Direct Sales Commission", -1)
const _hoisted_14 = {
  key: 0,
  value: "MLC"
}
const _hoisted_15 = {
  key: 1,
  class: "seq-amount-field__currency"
}
const _hoisted_16 = { class: "seq-field-hint" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Select a source to enter an amount. ")
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "Encashment is currently unavailable because you have reached the maximum number of OTPs per day. Please try again at 12 midnight of the next day. Sorry for the inconvenience.", -1)
const _hoisted_20 = { class: "seq-amount-field mt-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "seq-amount-field__label" }, "Encashment Type", -1)
const _hoisted_22 = { class: "seq-amount-field__side" }
const _hoisted_23 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select type", -1)
const _hoisted_24 = {
  key: 0,
  value: "B"
}
const _hoisted_25 = {
  key: 1,
  value: "C"
}
const _hoisted_26 = {
  key: 2,
  value: "S"
}
const _hoisted_27 = {
  key: 3,
  value: "R"
}
const _hoisted_28 = {
  key: 4,
  value: "E"
}
const _hoisted_29 = {
  key: 5,
  value: "T"
}
const _hoisted_30 = {
  key: 6,
  value: "M"
}
const _hoisted_31 = {
  key: 0,
  id: "divChequeBranch",
  class: "seq-amount-field mt-3"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "seq-amount-field__label" }, "Select Branch", -1)
const _hoisted_33 = { class: "seq-amount-field__side" }
const _hoisted_34 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Branch", -1)
const _hoisted_35 = {
  key: 1,
  id: "divCashBranch",
  class: "seq-amount-field mt-3"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "seq-amount-field__label" }, "Select Branch", -1)
const _hoisted_37 = { class: "seq-amount-field__side" }
const _hoisted_38 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Branch", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "mb-5" }, null, -1)
const _hoisted_40 = {
  key: 3,
  class: "seq-breakdown"
}
const _hoisted_41 = { class: "seq-breakdown__row" }
const _hoisted_42 = { class: "seq-breakdown__label" }
const _hoisted_43 = { class: "seq-breakdown__value" }
const _hoisted_44 = { class: "seq-breakdown__row" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Fee", -1)
const _hoisted_46 = { class: "seq-breakdown__value" }
const _hoisted_47 = { class: "seq-breakdown__row seq-breakdown__row--total" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "You will receive", -1)
const _hoisted_49 = { class: "seq-breakdown__value" }
const _hoisted_50 = {
  key: 0,
  class: "row mb-5 text-center"
}
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Your Bank Account(s)", -1)
const _hoisted_54 = { class: "mt-5 mb-5" }
const _hoisted_55 = {
  key: 1,
  class: "card"
}
const _hoisted_56 = { class: "card-body p-5" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "mb-3" }
const _hoisted_59 = {
  key: 1,
  class: "btn btn-sm btn-primary",
  type: "button"
}
const _hoisted_60 = {
  key: 1,
  class: "row mb-5",
  id: "encashment_buttons"
}
const _hoisted_61 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_63 = {
  key: 2,
  class: "row mb-5",
  id: "encashment_confirmation"
}
const _hoisted_64 = { class: "mw-500px mx-auto" }
const _hoisted_65 = /*#__PURE__*/_createVNode("p", null, "This encashment will use the details below: ", -1)
const _hoisted_66 = { class: "seq-breakdown" }
const _hoisted_67 = { class: "seq-breakdown__row" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Bank", -1)
const _hoisted_69 = {
  class: "seq-breakdown__value",
  id: "bank"
}
const _hoisted_70 = { class: "seq-breakdown__row" }
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Account Number", -1)
const _hoisted_72 = {
  class: "seq-breakdown__value",
  id: "acctno"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("p", { class: "text-muted mt-3 mb-3 text-center" }, "Click proceed if all details are correct.", -1)
const _hoisted_74 = { class: "row mb-5" }
const _hoisted_75 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_77 = {
  key: 3,
  class: "row mb-5",
  id: "encashment_confirmation"
}
const _hoisted_78 = { class: "mw-500px mx-auto" }
const _hoisted_79 = /*#__PURE__*/_createVNode("p", null, "This encashment will use the details below: ", -1)
const _hoisted_80 = { class: "seq-breakdown" }
const _hoisted_81 = { class: "seq-breakdown__row" }
const _hoisted_82 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Mobile Number", -1)
const _hoisted_83 = {
  class: "seq-breakdown__value",
  id: "bibo_mobile"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("p", { class: "text-muted mt-3 mb-0 text-center" }, "Click proceed if all details are correct.", -1)
const _hoisted_85 = { class: "row mb-5" }
const _hoisted_86 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_88 = {
  key: 4,
  class: "row mb-5",
  id: "encashment_confirmation"
}
const _hoisted_89 = { class: "mw-500px mx-auto" }
const _hoisted_90 = /*#__PURE__*/_createVNode("p", null, "This encashment will use the details below: ", -1)
const _hoisted_91 = { class: "seq-breakdown" }
const _hoisted_92 = { class: "seq-breakdown__row" }
const _hoisted_93 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Mobile Number", -1)
const _hoisted_94 = {
  class: "seq-breakdown__value",
  id: "mobile_money_accountno"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("p", { class: "text-muted mt-3 mb-0 text-center" }, "Click proceed if all details are correct.", -1)
const _hoisted_96 = { class: "row mb-5" }
const _hoisted_97 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_98 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_99 = {
  key: 5,
  class: "row mb-5",
  id: "encashment_CHEQUEconfirmation"
}
const _hoisted_100 = { class: "mw-500px mx-auto" }
const _hoisted_101 = /*#__PURE__*/_createVNode("p", { class: "dashboardFontStyle" }, "This encashment will use the details below: ", -1)
const _hoisted_102 = { class: "seq-breakdown" }
const _hoisted_103 = { class: "seq-breakdown__row" }
const _hoisted_104 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "First Name", -1)
const _hoisted_105 = {
  class: "seq-breakdown__value",
  id: "fnameCHEQUE"
}
const _hoisted_106 = { class: "seq-breakdown__row" }
const _hoisted_107 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Last Name", -1)
const _hoisted_108 = {
  class: "seq-breakdown__value",
  id: "lnameCHEQUE"
}
const _hoisted_109 = {
  key: 0,
  class: "dashboardFontStyle mt-3"
}
const _hoisted_110 = /*#__PURE__*/_createVNode("p", { class: "dashboardFontStyle text-center mb-3" }, "Check if all details are correct. And then click Proceed button.", -1)
const _hoisted_111 = { class: "row mb-5 text-center" }
const _hoisted_112 = { for: "checkboxCHEQUE" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" All details are correct.")
const _hoisted_114 = { class: "row mb-5" }
const _hoisted_115 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_117 = {
  key: 6,
  class: "row mb-5",
  id: "encashment_CASHconfirmation"
}
const _hoisted_118 = { class: "mw-500px mx-auto" }
const _hoisted_119 = {
  key: 0,
  class: "dashboardFontStyle"
}
const _hoisted_120 = {
  key: 1,
  class: "dashboardFontStyle"
}
const _hoisted_121 = /*#__PURE__*/_createVNode("p", { class: "dashboardFontStyle" }, "This encashment will use the details below:", -1)
const _hoisted_122 = { class: "seq-breakdown" }
const _hoisted_123 = { class: "seq-breakdown__row" }
const _hoisted_124 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Branch", -1)
const _hoisted_125 = {
  class: "seq-breakdown__value",
  id: "cashBranch"
}
const _hoisted_126 = /*#__PURE__*/_createVNode("p", { class: "text-muted mt-3 mb-3 text-center" }, "Click proceed if all details are correct.", -1)
const _hoisted_127 = { class: "row mb-5" }
const _hoisted_128 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_130 = {
  key: 1,
  class: "col-xxl-12"
}
const _hoisted_131 = { class: "mw-500px mx-auto text-center py-5" }
const _hoisted_132 = /*#__PURE__*/_createVNode("h3", { class: "seq-otp-title fs-2" }, "Verify your encashment", -1)
const _hoisted_133 = /*#__PURE__*/_createVNode("p", { class: "seq-otp-subtitle" }, "Please enter the Chinatrust OTP sent to your mobile phone.", -1)
const _hoisted_134 = { class: "my-8" }
const _hoisted_135 = { class: "d-grid col-10 col-sm-8 mx-auto" }
const _hoisted_136 = {
  key: 2,
  class: "col-xxl-12"
}
const _hoisted_137 = {
  key: 0,
  class: "mw-500px mx-auto text-center py-5"
}
const _hoisted_138 = /*#__PURE__*/_createVNode("h3", { class: "seq-otp-title fs-2" }, "Verify your encashment", -1)
const _hoisted_139 = /*#__PURE__*/_createVNode("p", { class: "seq-otp-subtitle" }, "Please enter the OTP sent to your mobile phone.", -1)
const _hoisted_140 = { class: "my-8" }
const _hoisted_141 = { class: "d-grid col-10 col-sm-8 mx-auto" }
const _hoisted_142 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_143 = /*#__PURE__*/_createVNode("p", null, "1) Please upload (1) valid ID.", -1)
const _hoisted_144 = {
  key: 2,
  class: "row mb-5"
}
const _hoisted_145 = /*#__PURE__*/_createVNode("p", null, "2) Please upload a selfie while holding your valid ID.", -1)
const _hoisted_146 = {
  key: 3,
  class: "row mb-5"
}
const _hoisted_147 = /*#__PURE__*/_createTextVNode("Uploading. Please wait...")
const _hoisted_148 = {
  key: 3,
  class: "col-xxl-12"
}
const _hoisted_149 = { class: "px-3 px-md-9 py-5" }
const _hoisted_150 = /*#__PURE__*/_createVNode("p", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("strong", null, "Before we continue with your encashment,"),
  /*#__PURE__*/_createTextVNode(" please update your address (State/Region and your LGA) in the Profile Menu. ")
], -1)
const _hoisted_151 = /*#__PURE__*/_createVNode("div", { class: "seq-notice__example mb-3" }, [
  /*#__PURE__*/_createVNode("p", { class: "mb-1" }, [
    /*#__PURE__*/_createVNode("strong", null, "Example:")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "mb-1" }, [
    /*#__PURE__*/_createVNode("strong", null, "Country:"),
    /*#__PURE__*/_createTextVNode(" Nigeria")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "mb-1" }, [
    /*#__PURE__*/_createVNode("strong", null, "Region/State:"),
    /*#__PURE__*/_createTextVNode(" Abia")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "mb-0" }, [
    /*#__PURE__*/_createVNode("strong", null, "City/LGA:"),
    /*#__PURE__*/_createTextVNode(" Aba North")
  ])
], -1)
const _hoisted_152 = { class: "mb-0" }
const _hoisted_153 = /*#__PURE__*/_createTextVNode(" Please click ")
const _hoisted_154 = /*#__PURE__*/_createTextVNode(" to update your address. ")
const _hoisted_155 = {
  key: 4,
  class: "col-xxl-12"
}
const _hoisted_156 = { class: "px-3 px-md-9 py-5" }
const _hoisted_157 = /*#__PURE__*/_createVNode("p", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("strong", null, "Before we continue with your encashment,"),
  /*#__PURE__*/_createTextVNode(" please update your "),
  /*#__PURE__*/_createVNode("strong", null, "KRA Number"),
  /*#__PURE__*/_createTextVNode(" in the Profile Menu. ")
], -1)
const _hoisted_158 = { class: "mb-0" }
const _hoisted_159 = /*#__PURE__*/_createTextVNode(" Please click ")
const _hoisted_160 = /*#__PURE__*/_createTextVNode(" to update your ")
const _hoisted_161 = /*#__PURE__*/_createVNode("strong", null, "KRA Number", -1)
const _hoisted_162 = /*#__PURE__*/_createTextVNode(". ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_OtpInput = _resolveComponent("OtpInput")
  const _component_font = _resolveComponent("font")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      (_ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Wallet.svg" })
              ]),
              _hoisted_4
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        (_ctx.hasPendingChinatrustOTP == false && _ctx.hasPendingEncashmentOTP == false && _ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_ctx.isShowEncashmentDestinationDropdown == true)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode("div", _hoisted_10, [
                        _withDirectives(_createVNode("input", {
                          type: "number",
                          class: "seq-amount-field__input",
                          placeholder: "0.00",
                          id: "encashment_amount",
                          disabled: _ctx.ccode == 0 && _ctx.showEncashmentForm == false,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model_encashment_amount = $event)),
                          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clampAmount()))
                        }, null, 40, ["disabled"]), [
                          [_vModelText, _ctx.model_encashment_amount]
                        ]),
                        _createVNode("div", _hoisted_11, [
                          (_ctx.ccode == 0)
                            ? _withDirectives((_openBlock(), _createBlock("select", {
                                key: 0,
                                class: "seq-amount-field__select",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.model_source_selected = $event)),
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSourceChange()))
                              }, [
                                _hoisted_12,
                                _hoisted_13,
                                (_ctx.isShowMLCEncashment)
                                  ? (_openBlock(), _createBlock("option", _hoisted_14, "Group Sales Commission"))
                                  : _createCommentVNode("", true)
                              ], 544)), [
                                [_vModelSelect, _ctx.model_source_selected]
                              ])
                            : (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.currency), 1))
                        ])
                      ]),
                      _createVNode("div", _hoisted_16, [
                        (_ctx.ccode == 0 && _ctx.showEncashmentForm == false)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _hoisted_17
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Available: " + _toDisplayString(_ctx.numberWithCommas(Number(_ctx.sourceMax).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                            ], 64))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isShowEncashmentDestinationDropdown == false)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _hoisted_19
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isShowEncashmentDestinationDropdown == true)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode("div", _hoisted_22, [
                          _withDirectives(_createVNode("select", {
                            class: "seq-amount-field__select",
                            id: "destination",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.model_destination_selected = $event)),
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.destinationChange()))
                          }, [
                            _hoisted_23,
                            (_ctx.isAllowBankEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_24, "Bank (" + _toDisplayString(_ctx.b) + ")", 1))
                              : _createCommentVNode("", true),
                            (_ctx.isAllowChequeEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_25, "Cheque"))
                              : _createCommentVNode("", true),
                            (_ctx.isAllowCashEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_26, "Cash"))
                              : _createCommentVNode("", true),
                            (_ctx.isAllowIbayadEncashment == true && _ctx.isShowEncashmentDestinationDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_27, "BanKO ATM/ID"))
                              : _createCommentVNode("", true),
                            (_ctx.ccode == 0 && _ctx.isShowChinatrustEncashDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_28, "Chinatrust"))
                              : _createCommentVNode("", true),
                            (_ctx.isShowBiboEncashDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_29, "BIBO SuperApp"))
                              : _createCommentVNode("", true),
                            (_ctx.isShowMobileMoneyEncashDropdown == true)
                              ? (_openBlock(), _createBlock("option", _hoisted_30, "Mobile Money"))
                              : _createCommentVNode("", true)
                          ], 544), [
                            [_vModelSelect, _ctx.model_destination_selected]
                          ])
                        ])
                      ]),
                      (_ctx.ccode == 0 && _ctx.isShowChequeBranchDropdown == true && _ctx.isShowDivChequeBranch == true)
                        ? (_openBlock(), _createBlock("div", _hoisted_31, [
                            _hoisted_32,
                            _createVNode("div", _hoisted_33, [
                              _withDirectives(_createVNode("select", {
                                class: "seq-amount-field__select",
                                id: "chequereleasingbranch",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.chequereleasebranchcode_selected = $event))
                              }, [
                                _hoisted_34,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branches, (item, index) => {
                                  return (_openBlock(), _createBlock("option", {
                                    key: index,
                                    value: item.branch_code
                                  }, _toDisplayString(item.description), 9, ["value"]))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.chequereleasebranchcode_selected]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.ccode == 0 && _ctx.isAllowCashEncashment == true && _ctx.isShowDivCashBranch == true)
                        ? (_openBlock(), _createBlock("div", _hoisted_35, [
                            _hoisted_36,
                            _createVNode("div", _hoisted_37, [
                              _withDirectives(_createVNode("select", {
                                class: "seq-amount-field__select",
                                id: "cashreleasingbranch",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.cashreleasebranchcode_selected = $event))
                              }, [
                                _hoisted_38,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branches, (item, index) => {
                                  return (_openBlock(), _createBlock("option", {
                                    key: index,
                                    value: item.branch_code
                                  }, _toDisplayString(item.description), 9, ["value"]))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.cashreleasebranchcode_selected]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_39
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isShowEncashmentDestinationDropdown == true)
                  ? (_openBlock(), _createBlock("div", _hoisted_40, [
                      _createVNode("div", _hoisted_41, [
                        _createVNode("span", _hoisted_42, "Tax (" + _toDisplayString(_ctx.taxRatePercent) + "%)", 1),
                        _createVNode("span", _hoisted_43, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.tax_amount).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                      ]),
                      _createVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode("span", _hoisted_46, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.fee_amount).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                      ]),
                      _createVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createVNode("span", _hoisted_49, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.netReceive).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isShowBankAccounts == true)
                ? (_openBlock(), _createBlock("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, [
                      (_ctx.bankaccountsList.length > 1)
                        ? (_openBlock(), _createBlock("div", _hoisted_52, [
                            _hoisted_53,
                            _withDirectives(_createVNode("select", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.currentlySelectedAccount = $event)),
                              class: "form-control form-select form-select-solid",
                              "data-kt-select2": "true",
                              "data-placeholder": "Select an option",
                              "data-allow-clear": "true",
                              "data-kt-initialized": "1",
                              onChange: _cache[10] || (_cache[10] = ($event: any) => {_ctx.updateSelectedBankAccount();})
                            }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bankaccountsList, (item, index) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: index,
                                  value: item.recid
                                }, _toDisplayString(item.bank) + " - " + _toDisplayString(item.accountno), 9, ["value"]))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, _ctx.currentlySelectedAccount]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_54, [
                        (_ctx.isShowAddZenithAccount)
                          ? (_openBlock(), _createBlock("label", {
                              key: 0,
                              class: "text-primary btn btn-link btn-sm mb-5",
                              type: "button",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showAddAccountForm()))
                            }, _toDisplayString(_ctx.addAccountFormLabel), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isShowAddAccountForm)
                          ? (_openBlock(), _createBlock("div", _hoisted_55, [
                              _createVNode("div", _hoisted_56, [
                                _createVNode("div", _hoisted_57, [
                                  _createVNode("div", _hoisted_58, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.newaccountno = $event)),
                                      class: "form-control form-control-solid",
                                      placeholder: "Zenith Account Number"
                                    }, null, 512), [
                                      [_vModelText, _ctx.newaccountno]
                                    ])
                                  ])
                                ]),
                                (_ctx.isSaving == false)
                                  ? (_openBlock(), _createBlock("button", {
                                      key: 0,
                                      class: "btn btn-sm btn-primary",
                                      type: "button",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveNewZenithAccount()))
                                    }, " Save Account "))
                                  : _createCommentVNode("", true),
                                (_ctx.isSaving == true)
                                  ? (_openBlock(), _createBlock("button", _hoisted_59, " Saving... "))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowEncashmentButtons && _ctx.isShowEncashmentDestinationDropdown == true)
                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                    _createVNode("div", _hoisted_61, [
                      _createVNode("input", {
                        type: "button",
                        class: "btn btn-sm btn-seq-blue min-w-100px",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.reset_encashment();}),
                        id: "cancel",
                        disabled: _ctx.isCancelBtnDisabled,
                        value: "Reset"
                      }, null, 8, ["disabled"]),
                      _hoisted_62,
                      _createVNode("input", {
                        type: "button",
                        class: "btn btn-sm btn-seq-green min-w-100px",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.process_encashment();}),
                        id: "encash",
                        disabled: _ctx.isEncashBtnDisabled,
                        value: "Encash"
                      }, null, 8, ["disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowEncashmentConfirmation)
                ? (_openBlock(), _createBlock("div", _hoisted_63, [
                    _createVNode("div", _hoisted_64, [
                      _hoisted_65,
                      _createVNode("div", _hoisted_66, [
                        _createVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createVNode("span", _hoisted_69, _toDisplayString(_ctx.display_b), 1)
                        ]),
                        _createVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createVNode("span", _hoisted_72, _toDisplayString(_ctx.display_ba), 1)
                        ])
                      ]),
                      _hoisted_73
                    ]),
                    _createVNode("div", _hoisted_74, [
                      _createVNode("div", _hoisted_75, [
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-blue min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                          id: "cancel"
                        }, " Cancel "),
                        _hoisted_76,
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-green min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.process_ibayadencashment();}),
                          id: "encash"
                        }, " Proceed ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowBiboEncashmentConfirmation)
                ? (_openBlock(), _createBlock("div", _hoisted_77, [
                    _createVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode("div", _hoisted_80, [
                        _createVNode("div", _hoisted_81, [
                          _hoisted_82,
                          _createVNode("span", _hoisted_83, _toDisplayString(_ctx.bibo_mobile), 1)
                        ])
                      ]),
                      _hoisted_84
                    ]),
                    _createVNode("div", _hoisted_85, [
                      _createVNode("div", _hoisted_86, [
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-blue min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                          id: "cancel"
                        }, " Cancel "),
                        _hoisted_87,
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-green min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.process_ibayadencashment();}),
                          id: "encash"
                        }, " Proceed ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowMobileMoneyEncashmentConfirmation)
                ? (_openBlock(), _createBlock("div", _hoisted_88, [
                    _createVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createVNode("div", _hoisted_91, [
                        _createVNode("div", _hoisted_92, [
                          _hoisted_93,
                          _createVNode("span", _hoisted_94, _toDisplayString(_ctx.mobile_money_accountno), 1)
                        ])
                      ]),
                      _hoisted_95
                    ]),
                    _createVNode("div", _hoisted_96, [
                      _createVNode("div", _hoisted_97, [
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-blue min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                          id: "cancel"
                        }, " Cancel "),
                        _hoisted_98,
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-green min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.process_ibayadencashment();}),
                          id: "encash"
                        }, " Proceed ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowChequeEncashmentConfirmation)
                ? (_openBlock(), _createBlock("div", _hoisted_99, [
                    _createVNode("div", _hoisted_100, [
                      _hoisted_101,
                      _createVNode("div", _hoisted_102, [
                        _createVNode("div", _hoisted_103, [
                          _hoisted_104,
                          _createVNode("span", _hoisted_105, _toDisplayString(_ctx.fname), 1)
                        ]),
                        _createVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _createVNode("span", _hoisted_108, _toDisplayString(_ctx.lname), 1)
                        ])
                      ]),
                      (_ctx.showChequeWillBeReleased == true)
                        ? (_openBlock(), _createBlock("p", _hoisted_109, "*Check will be released to the account owner only.*"))
                        : _createCommentVNode("", true),
                      _hoisted_110
                    ]),
                    _createVNode("div", _hoisted_111, [
                      _createVNode("label", _hoisted_112, [
                        _createVNode("input", {
                          type: "checkbox",
                          id: "checkboxCHEQUE",
                          value: "",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.checkBoxValidator($event);})
                        }),
                        _hoisted_113
                      ])
                    ]),
                    _createVNode("div", _hoisted_114, [
                      _createVNode("div", _hoisted_115, [
                        _createVNode("input", {
                          type: "button",
                          class: "btn btn-sm btn-seq-blue min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                          id: "cancel",
                          disabled: _ctx.isCancelChequeBtnDisabled,
                          value: "Cancel"
                        }, null, 8, ["disabled"]),
                        _hoisted_116,
                        _createVNode("input", {
                          type: "button",
                          class: "btn btn-sm btn-seq-green min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.process_chequeencashment();}),
                          id: "btnChequeProceed",
                          disabled: _ctx.isChequeEncashBtnDisabled,
                          value: "Proceed"
                        }, null, 8, ["disabled"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowCashEncashmentConfirmation)
                ? (_openBlock(), _createBlock("div", _hoisted_117, [
                    _createVNode("div", _hoisted_118, [
                      (_ctx.ccode == 6)
                        ? (_openBlock(), _createBlock("p", _hoisted_119, "Please be reminded that you can only claim your cash encashment at our Dubai or Abu Dhabi office."))
                        : _createCommentVNode("", true),
                      (_ctx.ccode == 2)
                        ? (_openBlock(), _createBlock("p", _hoisted_120, "Please be reminded that you can only claim your cash encashment at our Brunei office."))
                        : _createCommentVNode("", true),
                      (_ctx.cashBranchDescription != '')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                            _hoisted_121,
                            _createVNode("div", _hoisted_122, [
                              _createVNode("div", _hoisted_123, [
                                _hoisted_124,
                                _createVNode("span", _hoisted_125, _toDisplayString(_ctx.cashBranchDescription), 1)
                              ])
                            ]),
                            _hoisted_126
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_127, [
                      _createVNode("div", _hoisted_128, [
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-blue min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => {_ctx.cancel_encashmentconfirmation();}),
                          id: "cancel"
                        }, " Cancel "),
                        _hoisted_129,
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-seq-green min-w-100px",
                          "data-bs-toggle": "modal",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => {_ctx.process_cashencashment();}),
                          id: "btnCashProceed"
                        }, " Proceed ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.hasPendingChinatrustOTP == true && _ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
            ? (_openBlock(), _createBlock("div", _hoisted_130, [
                _createVNode("div", _hoisted_131, [
                  _hoisted_132,
                  _hoisted_133,
                  _createVNode("div", _hoisted_134, [
                    _createVNode(_component_OtpInput, {
                      modelValue: _ctx.model_chinatrust_otp,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.model_chinatrust_otp = $event)),
                      length: 6
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_135, [
                    _createVNode("a", {
                      href: "#",
                      class: "btn btn-seq-blue",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => {_ctx.process_chinatrustOTP();})
                    }, "Verify")
                  ])
                ])
              ]))
            : (_ctx.hasPendingEncashmentOTP == true && _ctx.isRequiredNigeriaLGA == false && _ctx.isRequiredKenyaKRA == false)
              ? (_openBlock(), _createBlock("div", _hoisted_136, [
                  (_ctx.need_cheque_id_upload == false)
                    ? (_openBlock(), _createBlock("div", _hoisted_137, [
                        _hoisted_138,
                        _hoisted_139,
                        _createVNode("div", _hoisted_140, [
                          _createVNode(_component_OtpInput, {
                            modelValue: _ctx.model_encashment_otp,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.model_encashment_otp = $event)),
                            length: 6
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_141, [
                          _createVNode("a", {
                            href: "#",
                            class: "btn btn-seq-blue",
                            onClick: _cache[30] || (_cache[30] = ($event: any) => {_ctx.process_encashmentOTP();})
                          }, "Verify")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.need_cheque_id_upload == true && _ctx.need_cheque_id_selfie_upload == false && _ctx.currentlyUploading == false)
                    ? (_openBlock(), _createBlock("div", _hoisted_142, [
                        _hoisted_143,
                        _createVNode("input", {
                          type: "file",
                          id: "cheque_id",
                          ref: "cheque_id",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleChequeIDUpload()))
                        }, null, 544)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.need_cheque_id_upload == true && _ctx.need_cheque_id_selfie_upload == true && _ctx.currentlyUploading == false)
                    ? (_openBlock(), _createBlock("div", _hoisted_144, [
                        _hoisted_145,
                        _createVNode("input", {
                          type: "file",
                          id: "cheque_id_selfie",
                          ref: "cheque_id_selfie",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleChequeIDSelfieUpload()))
                        }, null, 544)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentlyUploading == true)
                    ? (_openBlock(), _createBlock("div", _hoisted_146, [
                        _createVNode("p", null, [
                          _createVNode(_component_font, {
                            color: "green",
                            size: "5"
                          }, {
                            default: _withId(() => [
                              _hoisted_147
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.isRequiredNigeriaLGA == true)
                ? (_openBlock(), _createBlock("div", _hoisted_148, [
                    _createVNode("div", _hoisted_149, [
                      _createVNode(_component_SeqNoticeCard, {
                        variant: "warning",
                        title: "Profile update required"
                      }, {
                        default: _withId(() => [
                          _hoisted_150,
                          _hoisted_151,
                          _createVNode("p", _hoisted_152, [
                            _hoisted_153,
                            _createVNode("a", {
                              onClick: _cache[33] || (_cache[33] = ($event: any) => {_ctx.goToProfilePage();}),
                              href: "javascript:void(0);"
                            }, "here"),
                            _hoisted_154
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_ctx.isRequiredKenyaKRA == true)
                  ? (_openBlock(), _createBlock("div", _hoisted_155, [
                      _createVNode("div", _hoisted_156, [
                        _createVNode(_component_SeqNoticeCard, {
                          variant: "warning",
                          title: "Profile update required"
                        }, {
                          default: _withId(() => [
                            _hoisted_157,
                            _createVNode("p", _hoisted_158, [
                              _hoisted_159,
                              _createVNode("a", {
                                onClick: _cache[34] || (_cache[34] = ($event: any) => {_ctx.goToProfilePage();}),
                                href: "javascript:void(0);"
                              }, "here"),
                              _hoisted_160,
                              _hoisted_161,
                              _hoisted_162
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
})